import css from 'styled-jsx/css'
import { colors } from '../../../styles'

export default css`
.input-validation-group {
  padding: 48px;
}

.validation-text {
  display: block;
  padding-top: 12px;
}

.validation-text.is-valid {
  color: #68b000;
}

.validation-text.is-invalid {
  color: #F33;
}

.button-group {
  display: flex;
  justify-content: space-around;
}

.input {
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  font-size: 24px;
  color: #666;
  background: #e5e5e5;
  border: 2px solid #d4d4d4;
  border-radius: 24px;
  box-shadow: inset 0 1px 5px rgba(0,0,0,.075);
  display: block;
  height: 48px;
  padding: 0 1.5em;
  transition: all .5s ease-in;
  -webkit-appearance: none;
}

.input:focus {
  border-color: ${colors.IconButtonPurple};
  color: #000;
  outline: 0;
}

.input.is-valid {
  border-color: #68b000;
}

.input.is-invalid {
  border-color: #F33;
}

.input-container {
  display: flex;
  position: relative;
  max-width: 300px;
  margin: 0 auto;
}

.icon-container {
  display: flex;
  align-items: center;
  position: absolute;
  height: 100%;
  right: 12px;
}
`
